module.exports = "<section>\r\n    <large-card class=first></large-card>\r\n    <large-card></large-card>\r\n</section>"